import { ParcelSchema } from "@redotech/redo-model/outbound-labels/parcel";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const getParcels = {
  name: "getParcels" as const,
  input: zNull(),
  output: z.object({ parcels: z.array(ParcelSchema) }),
};
